import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import DatosComponent from "./Componentes/Datos/Datos.component";
import ModalMensajeComponent from "./../../Shared/Componentes/ModalMensaje/ModalMensaje.component";
import LoaderPortal from "./../../Portales/Loader/Loader.portal";
import * as loginActions from "./../../Core/Actions/Login.actions";
import "./Registro.page.scss";

class RegistroPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Modal: {
        Mostrar: false,
        Mensaje: "",
      },
      Usuario: {
        Nombre: "",
        Dni: "",
        Telefono: "",
        Usuario: "",
        Clave: "",
        ConfClave: "",
      },
    };
  }

  componentDidMount() {
    this.setState({
      Modal: {
        Mostrar: false,
        Mensaje: "",
      },
      Usuario: {
        Nombre: "",
        Dni: "",
        Telefono: "",
        Usuario: "",
        Clave: "",
        ConfClave: "",
      },
    });
  }

  handleInputChange = (e) => {
    this.setState({
      Usuario: {
        ...this.state.Usuario,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleMostrarModal = () => {
    this.setState({
      Modal: {
        Mostrar: !this.state.Modal.Mostrar,
        Mensaje: "",
      },
    });
  };

  handleAceptarClick = async () => {
    const { Usuario } = this.state;

    const { Nombre, Usuario: UsuarioCliente, Clave, ConfClave } = Usuario;

    const { consumirRegistro } = this.props;

    if (
      Nombre === "" ||
      UsuarioCliente === "" ||
      Clave === "" ||
      ConfClave === ""
    ) {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: "Debe ingresar todos los datos necesarios para el registro.",
        },
      });
      return;
    }

    if (Clave !== ConfClave) {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: "Las claves no coinciden",
        },
      });
      return;
    }

    await consumirRegistro(Usuario);

    if (this.props.loginReducer.Resultado !== "S") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: this.props.loginReducer.Mensaje,
        },
      });
      return;
    } else {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: `Le enviamos un email de verificación, si no lo recibio revise su carpeta de spam o que el correo sea correcto.`,
        },
      });

      await setTimeout(() => {
        this.props.history.push("/Login");
      }, 5000);

      return;
    }
  };

  render() {
    return (
      <>
        <LoaderPortal />
        <ModalMensajeComponent
          mostrar={this.state.Modal.Mostrar}
          handleCerrar={this.handleMostrarModal}
        >
          <h5>{this.state.Modal.Mensaje}</h5>
        </ModalMensajeComponent>
        <div className="row border-bottom">
          <div className="col-12">
            <h3 className="text-primary font-weight-bold">
              Registro de cliente
            </h3>
          </div>
        </div>
        <div className="Registro">
          <div className="Registro__Imagen"></div>
          <div className="Registro__Informacion">
            <div className="row">
              <div className="col-12">
                <DatosComponent
                  datosChange={this.handleInputChange}
                  Usuario={this.state.Usuario}
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-12 col-lg-6 mb-2 mb-md-0">
                <Link to="/Login">
                  <Button variant="link" type="button" block="true">
                    Cancelar
                  </Button>
                </Link>
              </div>
              <div className="col-12 col-lg-6">
                <Button
                  variant="secondary"
                  type="button"
                  block="true"
                  onClick={this.handleAceptarClick}
                >
                  Aceptar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ loginReducer }) => {
  return { loginReducer };
};

const mapDispatchToProps = {
  ...loginActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistroPage);
